import React, { ReactNode } from "react";
import Icon from "./Icon";

interface CardsProps {
  classes?: string; // Optional string for extra classes
  edit?: boolean; // Optional boolean for edit mode
  setEdit?: (edit: boolean) => void; // Optional function to toggle edit mode
  children?: ReactNode; // React children (content inside the card)
  id?: string; // Optional id for the card
}

export const Cards: React.FC<CardsProps> = ({
  classes,
  edit,
  setEdit,
  children,
  id,
}) => {
  return (
    <div className={"card " + classes} id={id}>
      {edit && setEdit && (
        <button className="card__edit" onClick={() => setEdit(true)}>
          Edit <Icon id="edit" size={14} className="card__edit-icon" />
        </button>
      )}

      {children}
    </div>
  );
};
